// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__7DW1z","checkmark":"Checkbox_checkmark__3dUTp"};